import type { Locale } from 'date-fns';
import { da } from 'date-fns/locale/da';
import { bootstrappedData as bootstrapped } from './bootstrappedData';

export class LocaleUtils {
	public static getLocale(): Locale {
		// TODO: Return locale based on bootstrapped language.
		// NOTE: Curently date-fns does not support greenlandic/kl locale
		// return bootstrapped?.Language == 'kl'? kl: da;

		return da;
	}

	public static getDefaultPhonePrefix(): string {
		return '+299 ';
	}

	public static getDateTimeFormat(): string {
		return bootstrapped?.DateTimeFormat;
	}

	public static getDateFormat(): string {
		return bootstrapped?.DateFormat;
	}

	public static getTimeFormat(): string {
		return bootstrapped?.TimeFormat;
	}

	public static getRegionName(): string {
		return bootstrapped?.Region;
	}

	public static getCurrentTimeZoneLabel(): string {
		const locales = [bootstrapped?.Language, 'kl', 'da'];

		const offset = new Date().toLocaleDateString(locales, {
			day: '2-digit',

			timeZoneName: 'longOffset' as any,
		});
		const offsetTrimmed = offset.slice(offset.indexOf(' '));

		const timeZoneName = new Date().toLocaleDateString(locales, {
			day: '2-digit',
			timeZoneName: 'long',
		});
		const timeZoneNameTrimmed = timeZoneName.slice(timeZoneName.indexOf(' '));

		// firefox returns the offset instead of the name for the 'kl' locale
		if (offsetTrimmed === timeZoneNameTrimmed) return offsetTrimmed;

		return `${offsetTrimmed} ${timeZoneNameTrimmed}`;
	}
}
